import Axios from './Axios';

export const getLiveMetrics = () => Axios.get('/api/v1/metrics/server/live');

export const getServerMetrics = (period) =>
  Axios.get('/api/v1/metrics/server', { params: { period } });

export const getTopSearches = (period) =>
  Axios.get('/api/v1/metrics/server/top-searches', { params: { period } });

export const getTrends = (metric, days) =>
  Axios.get('/api/v1/metrics/server/trends', { params: { metric, days } });

export const getUserMetrics = (id, period) =>
  Axios.get(`/api/v1/metrics/user/${id}`, { params: { period } });

export const cleanupEvents = () => Axios.post('/api/v1/metrics/maintenance/cleanup-events');
